import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { EnumQuestion } from 'src/Models/Enum/EnumQuestions';
import { Questions } from 'src/Models/Questions';

@Injectable({
    providedIn: 'root'
})
export class HelperValidAnwserQuestions {

    static validQuestionAnwser(form, question: Questions, value): boolean {
        switch (question.fk_type_question) {
            case EnumQuestion.Nps:
            case EnumQuestion.ScaleZeroToTen:
                const validAnwser = this.validQuestionNumeric(value, 0, 10);
                if (validAnwser) this.setControlValue(form, Number(value))
                return validAnwser;
            case EnumQuestion.Stars:
            case EnumQuestion.OneFive:
            case EnumQuestion.Smiles:
                const validAnwserScale = this.validQuestionNumeric(value, 1, 5);
                if (validAnwserScale) this.setControlValue(form, Number(value))
                return validAnwserScale;
            case EnumQuestion.LikeDislike:
                const validAnwserLD = this.validQuestionLikeDislike(value, question);
                if (validAnwserLD) this.setControlValue(form, validAnwserLD);
                return validAnwserLD != null;
            case EnumQuestion.LongText:
                if(value != '') this.setControlValue(form, value);
                return true;
            default:
                return false;
        }
    }

    private static validQuestionNumeric(number: number, min: number, max: number): boolean {
        return number >= min && number <= max;
    }

    private static validQuestionLikeDislike(value, question: Questions): string{
        if(value == 'like') return question.high_score_label;
        else if(value == 'dislike') return question.low_score_label;
        return null;
    }

    private static setControlValue(form, value) {
        (<FormGroup>(form.get('responses').get('data')['controls'])[0]).get('value').setValue(value)
    }
}